import axios from "axios";
import { toast } from "bulma-toast";

export function createPaypalBnt(getValues, with_aut, onComplete, onCancelled, onBeforeCreateOrder) {
    const state = {
        rdvID: null,
        orderID: null,
        clientID: null
    };

    return window.paypal.Buttons({
        async createOrder(data, actions) {

            // vérification des conditions avant création de la commande
            if(!onBeforeCreateOrder()){
                return;
            }
            // return false;
            if (state.orderID != null) {
                return state.orderID;
            }
            try {
                const values = await getValues();
                const payload = {
                    rdv_id: values.rdv_id || null,
                    startDate: values.day + ' ' + values.heure,
                    idAgenda: values.idAgenda,
                    idPrestation: values.idPrestation,
                    idLocation: values.idLocation,
                    groupSize: values.groupSize,
                    paymentProviderName: "paypal",
                    client: values.client
                };
                const response = await axios.post(
                    with_aut ? "/rdv/payment/create-order" : "/rdv/without_auth/payment/create-order",
                    payload
                );
                const body = response.data;
                state.rdvID = body.rdv_id
                state.orderID = body.id
                state.clientID = body.client_id
                return body.id;
            } catch (error) {
                let message = error.response?.data?.message ?? error.message ?? "Le rendez-vous n'a pas pu être créé.";
                toast({
                    message,
                    type: "is-danger",
                    duration: 5000,
                    pauseOnHover: true,
                });
                return null;
            }
        },
        async onCancel(data) {
            state.orderID = null;
            try {
                await with_aut ? axios.delete("/rdv/payment/cancel-order/" + data.orderID) : axios.post("/rdv/without_auth/payment/cancel-order/" + data.orderID, {
                    startDate,
                    idAgenda: values.idAgenda,
                    idPrestation: values.idPrestation,
                    idLocation: values.idLocation,
                    groupSize: values.groupSize,
                    paymentProviderName: "paypal",
                    client: values.client
                });
            } catch (err) {
                console.error(err);
            }
            // if (onCancelled) {
            //     onCancelled();
            // }
        },
        async onApprove(data, actions) {
            const response = await axios.post(
                                "/rdv/payment/capture-payment/" + data.orderID,
                                {client_id: state.clientID}
                            );
            const captureData = await response.data;
            if (captureData.error === "INSTRUMENT_DECLINED") {
                console.log("INSTRUMENT_DECLINED :");
                return actions.restart();
            }
            onComplete(
                state.rdvID,
                state.clientID,
                "Rendez-vous créé avec succès. Vous recevrez une confirmation par mail."
            );
        },
        onError(err) {
            // vérification des conditions avant création de la commande
            if(!onBeforeCreateOrder()){
                return;
            }
            console.log(err);
            toast({
                message: err.message || "Le rendez-vous n'a pas pu être créé.",
                type: "is-danger",
                duration: 5000,
                pauseOnHover: true,
            });
        }
    });
}

export async function stripeHandlePayment(values) {
    try {
        const startDate = values.day + ' ' + values.heure;
        const response = await axios.post("/rdv/payment/create-order", {
            rdv_id: values.rdv_id || null,
            startDate,
            idAgenda: values.idAgenda,
            idPrestation: values.idPrestation,
            idLocation: values.idLocation,
            group_size: values.groupSize,
            paymentProviderName: "stripe",
        });
        return response.data.url;
    } catch (error) {
        let message = error.response?.data?.message ?? error.message ?? "Le rendez-vous n'a pas pu être créé.";
        toast({
            message,
            type: "is-danger",
            duration: 5000,
            pauseOnHover: true,
        });
        return null;
    }
}

export async function handlePayment(values,type,with_aut=true,token=null) {
    try {
        const startDate = values.day + ' ' + values.heure;
        const url = with_aut ?
                        "/rdv/payment/create-order" : 
                        "/rdv/without_auth/payment/create-order"
                        +(token ? '/token' : '');
        const response = await axios.post(url, 
            {
                startDate,
                idAgenda: values.idAgenda,
                idPrestation: values.idPrestation,
                location_id: values.location_id,
                group_size: values.groupSize,
                paymentProviderName: type,
                client: values.client,
                col1: values.col1,
                col2: values.col2,
                col3: values.col3,
                col4: values.col4,
                col5: values.col5,
            },
            { headers: { 'X-Form-Token': token } }
        );
        return response.data;
    } catch (error) {
        let message = error.response?.data?.message ?? error.message ?? "Le rendez-vous n'a pas pu être créé.";
        toast({
            message,
            type: "is-danger",
            duration: 5000,
            pauseOnHover: true,
        });
        return null;
    }
}
